import React, {
  Component,
  useState,
  Fragment,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardTitle,
} from "reactstrap";
import { AvField } from "availity-reactstrap-validation";
import Dropzone, { useDropzone } from "react-dropzone";
import { isArray } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import MinioClient from "../../services/minioClient";
import CreateBloc from "../../pages/Kepegawaian/Pensiun/Create/Blocs/CreateBloc";
import apiResponse from "../../services/apiResponse";

import Shimmer from "react-shimmer-effect";
import TreeDoc from "./preview/TreeDoc";
import Tree from "./folder/Tree";
import { ConfirmAlert } from "./alert";
import empty_folder from "../../assets/images/empty_folder.png";
import empty_document from "../../assets/images/empty_document.png";

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const CustomFileInput = (props) => {
  let createBloc = useMemo(() => new CreateBloc(), []);
  const [selectedFiles, setSelectedFiles] = useState(props.selectedFiles);
  const [selectedDms, setSelectedDms] = useState(null);
  const [isError, setIsError] = useState();
  const [errorAlertMessage, setErrorAlertMessage] = useState(
    "Hanya dapat memilih 1 file."
  );
  const {
    name,
    dms_name,
    validate,
    placeholder = "Click to upload.",
    errorMessage = "Harap pilih file",
    accept,
    style,
    onChange = null,
    isMultiple = false,
    isAvForm = true,
    col = "4",
    maxFiles = 1,
  } = props;

  const [folders, setFolders] = useState(null);
  const [documents, setDocuments] = useState(null);
  const [activeFolder, setActiveFolder] = useState(null);
  const [folderName, setfolderName] = useState("");
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalHeight, setModalHeight] = useState("auto");
  const [showFolder, setShowFolder] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(0);
  const [showDocument, setShowDocument] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [fileDMSSelected, setFileDMSSelected] = useState([]);
  const toggle = () => {
    setModal(!modal);
  };

  const onDrop = useCallback((acceptedFiles) => {
    if (isMultiple) {
      insertMultipleFiles(acceptedFiles);
    } else {
      insertFiles(acceptedFiles);
    }
  });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const handleAcceptedFiles = (files) => {
    if (isMultiple) {
      insertMultipleFiles(files);
    } else {
      insertFiles(files);
    }
    if (onChange) {
      onChange(files);
    }
    setModal(false);
  };

  const insertFiles = (files) => {
    if (files.length <= maxFiles) {
      let newArray = [];
      // if (isArray(selectedFiles)) {
      //   newArray = selectedFiles.slice();
      // }
      let isValid = true;
      const validFiles = files.map((file) => {
        Object.assign(file, {
          id: Math.random().toString(36).substring(2),
          preview: URL.createObjectURL(file),
          formattedSize: formatBytes(file.size),
        });

        if (isArray(selectedFiles)) {
          newArray.push(file);
        }

        return file.size > 5242880;
      });

      validFiles.forEach((i) => {
        if (i) isValid = false;
      });

      if (isValid) {
        setSelectedFiles(isArray(selectedFiles) ? newArray : files);
      } else {
        setErrorAlertMessage("Ukuran maksimal file adalah 5 MB (Mega Bytes)!");
        setIsError(true);
      }
      setModal(false);
    } else {
      setErrorAlertMessage(`Hanya dapat ${maxFiles} memilih file!`);
      setIsError(true);
    }
  };

  const insertMultipleFiles = (files) => {
    let newArray = [];
    // if (isArray(selectedFiles)) {
    //   newArray = selectedFiles.slice();
    // }

    if (files.length <= maxFiles) {
      let isValid = true;
      const validFiles = files.map((file) => {
        Object.assign(file, {
          id: Math.random().toString(36).substring(2),
          preview: URL.createObjectURL(file),
          formattedSize: formatBytes(file.size),
        });

        if (isArray(selectedFiles)) {
          newArray.push(file);
        }

        return file.size > 5242880;
      });

      validFiles.forEach((i) => {
        if (i) isValid = false;
      });

      if (isValid) {
        setSelectedFiles(isArray(selectedFiles) ? newArray : files);
      } else {
        setErrorAlertMessage("Ukuran maksimal file adalah 5 MB (Mega Bytes)!");
        setIsError(true);
      }
      setModal(false);
    } else {
      setErrorAlertMessage(`Hanya dapat ${maxFiles} memilih file!`);
      setIsError(true);
    }
  };

  const removeFiles = (file) => {
    console.log(selectedFiles);
    file = atob(file).split(",");

    const files = selectedFiles.slice();
    const id = file[0];

    let obj = files.find((x) => x.id === id);

    files.splice(files.indexOf(obj), 1);
    setSelectedFiles(files);
  };

  const handleUploadFromComputer = () => {
    setModal(false);
  };

  const handleUploadFromOtherSource = () => {
    var employee_uuid = document.getElementsByName("employee_uuid")[0].value;
    if (employee_uuid) {
      setShowFolder(true);
      setShowDocument(false);
      setFolders(null);
      setLoading(true);
      // setShowShimmer(1);
      // setModalHeight("auto");
      createBloc.fetchDMSList({ employee_uuid: employee_uuid });
    } else {
      alert("Pilih Pegawai Dulu!");
    }
  };

  const onFolderClicked = (data) => {
    var employee_uuid = document.getElementsByName("employee_uuid")[0].value;
    if (employee_uuid) {
      setActiveFolder(data);
      if (data.children.length == 0) {
        setLoading(true);
        setDocuments(null);
        setShowDocument(true);
        setfolderName("Cari Dokumen Pada Folder " + data.document_name);
        console.log("last folder nih");
        createBloc.fetchDocumentList({
          employee_uuid: employee_uuid,
          parent_uuid: data.document_uuid,
        });
      } else {
        setShowDocument(false);
      }
    } else {
      alert("Pilih Pegawai Dulu!");
    }
  };

  const selectDocument = async (data) => {
    if (fileDMSSelected.document_ext != "dir") {
      const response = await fetch(fileDMSSelected.document_path);

      const blob = await response.blob();
      const file = new File([blob], "image.jpg", { type: "image/jpeg" });
      const size = file ? file.size : 0;
      const datas = [
        {
          id: Math.random().toString(36).substring(2),
          type: fileDMSSelected.document_ext,
          name: fileDMSSelected.document_name,
          preview: fileDMSSelected.document_path,
          formattedSize: formatBytes(size),
        },
      ];
      setSelectedFiles(datas);
      setSelectedDms(fileDMSSelected.document_path_original);
      setModal(false);
    }
  };

  const getSelectedNode = (data) => {
    setFileDMSSelected(data);
    setShowUpload(true);
    // console.log("Data received in TreeDoc:", data);
  };

  const downloadDocument = (data) => {
    if (data.document_ext != "dir") {
      window.open(data.document_path, "_blank");
    }
  };

  // const addNewFiles = (newFiles) => {
  //   setSelectedFiles(newFiles);
  //   // if (selectedFiles?.length > 0) {
  //   //   setSelectedFiles([...selectedFiles, ...newFiles]);
  //   // } else {
  //   // }
  // };

  useEffect(() => {
    const subscription = createBloc.dmsListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            setFolders(response);
            console.log("klik folder");
            console.log(response);
            setLoading(false);
            // setShowShimmer(false);
          }
          break;
        case apiResponse.ERROR:
          setLoading(false);
          break;
        default:
          break;
      }
    });

    const subscription2 = createBloc.documentListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            console.log("respone klik folder");
            let response = result.data.response;
            setDocuments(response);
            setLoading(false);
          }
          break;
        case apiResponse.ERROR:
          setLoading(false);
          break;
        default:
          break;
      }
    });

    return () => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
      if (subscription2 && !subscription2.closed) {
        subscription2.unsubscribe();
      }
      // createBloc.dmsListChannel?.unsubscribe();
      // createBloc.documentListChannel?.unsubscribe();
    };
  }, []);

  return (
    <Fragment>
      <style>
        {`
            .show {
              display: block; /* Display when isVisible is true */
            }
            
            .hide {
              display: none; /* Hide when isVisible is false */
            }
          `}
      </style>
      <Dropzone
        onDrop={(acceptedFiles) => {
          handleAcceptedFiles(acceptedFiles);
        }}
        style={style}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone">
            {selectedFiles?.length > 0 ? (
              <Row
                className="dropzone-previews"
                id="file-previews"
                style={{ padding: 12 }}
              >
                {selectedFiles?.map((f, i) => {
                  return (
                    <Col md={col} key={i}>
                      <Card
                        style={{
                          alignItems: "center",
                          textAlign: "center",
                          padding: 10,
                        }}
                      >
                        <Row
                          className="align-items-center"
                          style={{ width: "-webkit-fill-available" }}
                        >
                          <Col md="12" style={{ padding: 10 }}>
                            {f.type.includes("image") && (
                              <img
                                data-dz-thumbnail=""
                                style={{
                                  maxHeight: 300,
                                  width: "inherit",
                                  objectFit: "cover",
                                }}
                                className="rounded bg-light"
                                alt={f.name}
                                src={f.preview}
                              />
                            )}
                            {f.type.includes("pdf") && (
                              <i
                                className="uil uil-document-info avatar-sm rounded"
                                style={{ fontSize: 80 }}
                              ></i>
                            )}
                            {!f.type.includes("image") &&
                              !f.type.includes("pdf") && (
                                <i
                                  className="uil uil-document-info avatar-sm rounded"
                                  style={{ fontSize: 80 }}
                                ></i>
                              )}
                          </Col>
                          <Col md="12">
                            <a
                              href={f.preview}
                              target="_blank"
                              className="text-muted font-weight-bold"
                              style={{ fontSize: 14 }}
                            >
                              {f.name}
                            </a>
                            <br />
                            <label
                              className="text-muted"
                              style={{ fontSize: 12 }}
                            >
                              {f.formattedSize}
                            </label>
                          </Col>
                          <Col
                            md="12"
                            className="mt-3"
                            style={{ textAlign: "right" }}
                          >
                            <i
                              onClick={() => removeFiles(btoa(f.id))}
                              className="uil uil-x btn btn-sm btn-default btn-outline-secondary"
                              style={{ fontSize: "20px", cursor: "pointer" }}
                            ></i>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            ) : (
              <div
                className="dz-message needsclick"
                onClick={toggle}
                style={{
                  cursor: "pointer",
                }}
              >
                {/* {...getRootProps()} */}
                <input {...getInputProps()} accept={accept} />
                <div className="mb-3">
                  <i className="display-4 text-muted uil uil-cloud-upload" />
                </div>
                <h4>{placeholder}</h4>
              </div>
            )}
          </div>
        )}
      </Dropzone>
      <div className="input-group mt-1">
        {/* {...getRootProps()} */}
        <input {...getInputProps()} accept={accept} />
        <input
          onClick={toggle}
          readOnly
          className="form-control"
          placeholder={placeholder}
          style={{
            background: "white",
            cursor: "pointer",
          }}
        />
        <div className="btn btn-primary btn-file" tabIndex="500">
          <i className="bi-folder2-open"></i>
          <span className="hidden-xs">Pilih Source Dokumen</span>
          <Button
            onClick={toggle}
            multiple=""
            // type="file"
            className="file"
            accept={accept}
            style={{
              top: 0,
              left: 0,
              minWidth: "100%",
              minHeight: "100%",
              textAlign: "right",
              opacity: 0,
              background: "none repeat scroll 0 0 transparent",
              cursor: "pointer",
              display: "block",
              position: "absolute",
            }}
          >
            {" "}
            Pilih File
          </Button>
        </div>
      </div>
      {isAvForm && (
        <span>
          <AvField
            name={name}
            validate={validate}
            type="hidden"
            value={selectedFiles}
            errorMessage={errorMessage}
          />
          <AvField
            name={dms_name}
            type="hidden"
            value={selectedDms}
            error
            Message={errorMessage}
          />
        </span>
      )}
      {isError && (
        <SweetAlert
          title={"Gagal!"}
          showCloseButton={false}
          showConfirm={true}
          confirmBtnBsStyle="danger"
          error
          onConfirm={() => {
            setIsError(false);
          }}
        >
          {errorAlertMessage}
        </SweetAlert>
      )}

      <Modal
        isOpen={modal}
        toggle={toggle}
        style={{
          maxWidth: "1500px",
          width: "90%",
          // maxHeight: "90vh",
          maxHeight: "1500px",
          height: "90%",
        }}
      >
        <ModalHeader toggle={toggle}>Upload Documents</ModalHeader>
        <ModalBody>
          <p>Choose the upload source:</p>
          <Row className="mb-3">
            <Col md="6">
              <div
                className="dropzone"
                onClick={handleUploadFromComputer}
                {...getRootProps()}
              >
                <div className="dz-message needsclick">
                  <input {...getInputProps()} accept={accept} />
                  <div className="mb-3">
                    <i className="display-4 text-muted uil uil-laptop-cloud" />
                  </div>
                  <h4> Upload from Computer</h4>
                </div>
              </div>
            </Col>
            <Col md="6">
              <div
                className="dropzone"
                onClick={handleUploadFromOtherSource}
                style={{ cursor: "pointer" }}
              >
                <div className="dz-message needsclick">
                  <input {...getInputProps()} accept={accept} />
                  <div className="mb-3">
                    <i className="display-4 text-muted uil uil-cloud-database-tree" />
                  </div>
                  <h4> Upload from DMS</h4>
                </div>
              </div>
            </Col>
          </Row>
          <br /> <br />
          <Row className="mb-3">
            {folders != null && folders.length == 0 ? (
              <Col md="6">
                <Col md="9">
                  <center>
                    <img src={empty_folder} className="img-fluid"></img>
                    <h3>No Folder!</h3>
                  </center>
                </Col>
              </Col>
            ) : (
              ""
            )}

            {folders != null ? (
              <Col md="6" className={`${showFolder ? "show" : "hide"}`}>
                {folders.length > 0 ? <CardTitle>Folder</CardTitle> : ""}
                <Tree
                  md="6"
                  treeData={folders}
                  folderClicked={onFolderClicked}
                  active={activeFolder?.document_uuid}
                />
              </Col>
            ) : (
              <>
                <Col md="6" className={`${showFolder ? "show" : "hide"}`}>
                  <Col md="12">
                    <Shimmer>
                      <div
                        className="md-3"
                        style={{
                          width: "100%",
                          height: 20,
                          marginBottom: "20px",
                        }}
                      ></div>
                    </Shimmer>
                  </Col>
                  <Col md="12">
                    <Shimmer>
                      <div
                        className="md-3"
                        style={{
                          width: "100%",
                          height: 20,
                          marginBottom: "20px",
                        }}
                      ></div>
                    </Shimmer>
                  </Col>
                  <Col md="12">
                    <Shimmer>
                      <div
                        className="md-3"
                        style={{
                          width: "100%",
                          height: 20,
                          marginBottom: "20px",
                        }}
                      ></div>
                    </Shimmer>
                  </Col>
                  <Col md="12">
                    <Shimmer>
                      <div
                        className="md-3"
                        style={{
                          width: "100%",
                          height: 20,
                          marginBottom: "20px",
                        }}
                      ></div>
                    </Shimmer>
                  </Col>
                  <Col md="12">
                    <Shimmer>
                      <div
                        className="md-3"
                        style={{
                          width: "100%",
                          height: 20,
                          marginBottom: "20px",
                        }}
                      ></div>
                    </Shimmer>
                  </Col>
                  <Col md="12">
                    <Shimmer>
                      <div
                        className="md-3"
                        style={{
                          width: "100%",
                          height: 20,
                          marginBottom: "20px",
                        }}
                      ></div>
                    </Shimmer>
                  </Col>
                </Col>
              </>
            )}

            {documents != null ? (
              <Col md="6" className={`${showDocument ? "show" : "hide"}`}>
                <CardTitle>{folderName}</CardTitle>
                {documents.length > 0 ? (
                  <TreeDoc
                    md="6"
                    treeData={documents}
                    folderClicked={selectDocument}
                    downloadDocument={downloadDocument}
                    active={activeFolder?.document_uuid}
                    nodeSelected={getSelectedNode}
                  />
                ) : (
                  <Col md="9">
                    <center>
                      <img src={empty_document} className="img-fluid"></img>
                      <h3>No Document!</h3>
                    </center>
                  </Col>
                )}
              </Col>
            ) : (
              <Col md="6" className={`${showDocument ? "show" : "hide"}`}>
                <Col md="12">
                  <Shimmer>
                    <div
                      className="md-3"
                      style={{
                        width: "100%",
                        height: 20,
                        marginBottom: "20px",
                      }}
                    ></div>
                  </Shimmer>
                </Col>
                <Col md="12">
                  <Shimmer>
                    <div
                      className="md-3"
                      style={{
                        width: "100%",
                        height: 20,
                        marginBottom: "20px",
                      }}
                    ></div>
                  </Shimmer>
                </Col>
                <Col md="12">
                  <Shimmer>
                    <div
                      className="md-3"
                      style={{
                        width: "100%",
                        height: 20,
                        marginBottom: "20px",
                      }}
                    ></div>
                  </Shimmer>
                </Col>
                <Col md="12">
                  <Shimmer>
                    <div
                      className="md-3"
                      style={{
                        width: "100%",
                        height: 20,
                        marginBottom: "20px",
                      }}
                    ></div>
                  </Shimmer>
                </Col>
                <Col md="12">
                  <Shimmer>
                    <div
                      className="md-3"
                      style={{
                        width: "100%",
                        height: 20,
                        marginBottom: "20px",
                      }}
                    ></div>
                  </Shimmer>
                </Col>
                <Col md="12">
                  <Shimmer>
                    <div
                      className="md-3"
                      style={{
                        width: "100%",
                        height: 20,
                        marginBottom: "20px",
                      }}
                    ></div>
                  </Shimmer>
                </Col>
              </Col>
            )}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className={`${showUpload ? "show" : "hide"}`}
            color="success"
            onClick={selectDocument}
          >
            Upload
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <ConfirmAlert
        // confirmTitle="Konfirmasi!"
        // confirmInfo="Apakah anda yakin akan menyimpan data ini?"
        loadingTitle="Mengambil Data..."
        loadingInfo="Tunggu beberapa saat"
        // successTitle="Berhasil!"
        // successInfo="Data berhasil disimpan"
        // failedTitle="Gagal!"
        // failedInfo="Data gagal disimpan"
        // showConfirm={this.state.confirm}
        showLoading={loading}
        // showSuccess={this.state.success}
        // showFailed={this.state.failed}
        // response={this.confirmResponse}
      />
    </Fragment>
  );
};

export const generateFormData = (query, fileField = "file") => {
  var formData = new FormData();
  for (var key in query) {
    if (isArray(fileField) && fileField.includes(key)) {
      fileField.forEach((file) => {
        var name = typeof file === "object" ? file.field : file;
        if (key === name && query[key].length) {
          query[key].forEach((value, index) => {
            if (typeof file === "object") {
              Object.assign(value, {
                customName: file.name !== "" ? file.name : value.name,
              });
            }
            formData.append(`${key}[]`, value);
          });
        }
      });
    } else if (
      key === (typeof fileField === "object" ? fileField.field : fileField)
    ) {
      if (query[key] != "") {
        query[key].forEach((value, index) => {
          if (typeof fileField === "object") {
            Object.assign(value, {
              customName: fileField.name !== "" ? fileField.name : value.name,
            });
          }
          formData.append(`${key}[]`, value);
        });
      }
    } else {
      let val = query[key];
      if (val == "null" || val == null) val = "";
      formData.append(key, val);
    }
  }

  return formData;
};

export const generateFormDataMultiple = (query, fileField = "file") => {
  var formData = new FormData();
  fileField = !isArray(fileField) ? [fileField] : fileField;
  var fileFields = [];
  fileField.map((item) => {
    fileFields.push(typeof item === "object" ? item.field : item);
  });

  for (var key in query) {
    if (fileFields.includes(key)) {
      fileField.forEach((file) => {
        var name = typeof file === "object" ? file.field : file;
        if (key === name && query[key].length) {
          query[key].forEach((value, index) => {
            if (typeof file === "object") {
              Object.assign(value, {
                customName: file.name !== "" ? file.name : value.name,
              });
            }
            formData.append(`${key}[]`, value);
          });
        }
      });
    } else {
      formData.append(key, query[key]);
    }
  }

  return formData;
};

export class Preview extends Component {
  minioClient = new MinioClient();

  constructor(props) {
    super(props);
    this.state = {
      url: {},
    };
  }

  getAllUrl = () => {
    if (this.props.value?.length > 0) {
      this.props.value?.map((f, i) => {
        if (f[this.props.fileSource] === "minio") {
          this.minioClient.get(f[this.props.filePath]).then((url) => {
            this.setState({
              url: {
                ...this.state.url,
                [i]: url,
              },
            });
          });
        } else {
          this.setState({
            url: {
              ...this.state.url,
              [i]: f[this.props.filePath],
            },
          });
        }
      });
    }
  };

  componentDidMount() {
    this.getAllUrl();
  }

  render() {
    // if (
    //   typeof this.props.value == "object" &&
    //   this.props.value !== null &&
    //   !Array.isArray(this.props.value)
    // ) {
    //   console.log("cek", Array.isArray(this.props.value));
    // }
    return (
      <Fragment>
        {this.props.value?.length > 0 ? (
          <Row className="dropzone-previews" id="file-previews">
            {this.props.value?.map((f, i) => {
              return this.state.url[i] ? (
                <Col md={this.props.col}>
                  <Card
                    style={{
                      alignItems: "center",
                      textAlign: "center",
                      padding: 10,
                    }}
                  >
                    <Row
                      className="align-items-center"
                      style={{ width: "-webkit-fill-available" }}
                    >
                      <Col md="12" style={{ padding: 10 }}>
                        {f[this.props.fileMimeType] ? (
                          <>
                            {f[this.props.fileMimeType]?.includes("image") && (
                              <img
                                data-dz-thumbnail=""
                                style={{
                                  maxHeight: 300,
                                  width: "inherit",
                                  objectFit: "cover",
                                }}
                                className="rounded bg-light"
                                alt={f[this.props.fileName]}
                                src={this.state.url[i]}
                              />
                            )}
                            {f[this.props.fileMimeType]?.includes("pdf") && (
                              <i
                                className="uil uil-document-info avatar-sm rounded"
                                style={{ fontSize: 80 }}
                              ></i>
                            )}
                            {!f[this.props.fileMimeType]?.includes("image") &&
                              !f[this.props.fileMimeType].includes("pdf") && (
                                <i
                                  className="uil uil-document-info avatar-sm rounded"
                                  style={{ fontSize: 80 }}
                                ></i>
                              )}
                          </>
                        ) : (
                          <i
                            className="uil uil-document-info avatar-sm rounded"
                            style={{ fontSize: 80 }}
                          ></i>
                        )}
                      </Col>
                      <Col md="12">
                        {f[this.props.fileName]}
                        <br />
                        <label className="text-muted" style={{ fontSize: 12 }}>
                          {formatBytes(f[this.props.fileSize])}
                        </label>
                      </Col>
                      <Col
                        md="12"
                        className="mt-3"
                        style={{ textAlign: "right" }}
                      >
                        <a
                          href={this.state.url[i]}
                          className="btn btn-sm btn-default btn-outline-secondary"
                          target="_blank"
                        >
                          <i
                            className="uil uil-eye"
                            style={{ fontSize: "20px", cursor: "pointer" }}
                          ></i>
                        </a>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              ) : null;
            })}
          </Row>
        ) : (
          <Fragment>
            {typeof this.props.value == "object" &&
            this.props.value !== null ? (
              <Fragment>
                <Row className="dropzone-previews" id="file-previews">
                  <Card
                    style={{
                      alignItems: "center",
                      textAlign: "center",
                      padding: 10,
                    }}
                    className="col-md-4 col-form-label"
                  >
                    <Row
                      className="align-items-center"
                      style={{ width: "-webkit-fill-available" }}
                    >
                      <Col md="12" style={{ padding: 10 }}>
                        {this.props.value &&
                        this.props.fileMimeType in this.props.value ? (
                          <>
                            {this.props.value[this.props.fileMimeType].includes(
                              "image"
                            ) && (
                              <img
                                data-dz-thumbnail=""
                                style={{
                                  maxHeight: 300,
                                  width: "inherit",
                                  objectFit: "cover",
                                }}
                                className="rounded bg-light"
                                alt={this.props.value[this.props.fileName]}
                                src={this.props.value[this.props.filePath]}
                              />
                            )}
                            {this.props.value[this.props.fileMimeType].includes(
                              "pdf"
                            ) && (
                              <i
                                className="uil uil-document-info avatar-sm rounded"
                                style={{ fontSize: 80 }}
                              ></i>
                            )}
                            {!this.props.value[
                              this.props.fileMimeType
                            ].includes("image") &&
                              !this.props.value[
                                this.props.fileMimeType
                              ].includes("pdf") && (
                                <i
                                  className="uil uil-document-info avatar-sm rounded"
                                  style={{ fontSize: 80 }}
                                ></i>
                              )}
                          </>
                        ) : (
                          <i
                            className="uil uil-document-info avatar-sm rounded"
                            style={{ fontSize: 80 }}
                          ></i>
                        )}
                      </Col>
                      <Col md="12">
                        <a
                          href={this.props.value[this.props.filePath]}
                          target="_blank"
                          className="text-muted font-weight-bold"
                        >
                          {this.props.value[this.props.fileName]}
                        </a>
                        <br />
                        {/* <label className="text-muted" style={{ fontSize: 12 }}>{formatBytes(this.props.value[this.props.fileSize])}</label> */}
                      </Col>
                      <Col
                        md="12"
                        className="mt-3"
                        style={{ textAlign: "right" }}
                      >
                        <a
                          href={this.props.value[this.props.filePath]}
                          className="btn btn-sm btn-default btn-outline-secondary"
                          target="_blank"
                        >
                          <i
                            className="uil uil-eye"
                            style={{ fontSize: "20px", cursor: "pointer" }}
                          ></i>
                        </a>
                      </Col>
                    </Row>
                  </Card>
                </Row>
              </Fragment>
            ) : (
              <Row className="dropzone-previews" id="file-previews">
                <Col md={this.props.col}>
                  <Card
                    style={{
                      alignItems: "center",
                      textAlign: "center",
                      padding: 10,
                    }}
                  >
                    <Row
                      className="align-items-center"
                      style={{ width: "-webkit-fill-available" }}
                    >
                      <Col md="12" style={{ padding: 10 }}>
                        <i
                          className="uil uil-document-info avatar-sm rounded"
                          style={{ fontSize: 80 }}
                        ></i>
                      </Col>
                      <Col md="12">
                        Tidak ada File
                        <br />
                        <label className="text-muted" style={{ fontSize: 12 }}>
                          -
                        </label>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}
Preview.defaultProps = {
  value: [],
  col: 3,
  fileName: "documents_name",
  filePath: "documents_path",
  fileMimeType: "documents_mime_type",
  fileSize: "documents_file_size",
  fileSource: "documents_source",
};
